import React from 'react';

import speakerIcon from '../../asset/img/common/speaker_icon.svg';
import chatIcon from '../../asset/img/main_chat_img.svg';

import SlideRightDialog from '../../components/common/SlideRightDialog';
import Typography from '../../components/common/Typography';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Banner = styled.div`
  border-radius: 10px;
  background: var(--GrayScale-100);
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ChatButton = styled.div`
  border-radius: 35px;
  background: var(--Primary-500, #7a5af8);
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  padding: 3px 0px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: #fff;
`;

const TaxChangeAlert = ({ isOpen, onClose }) => {
  const { taxChangePer } = useSelector(state => state.common);
  const navigate = useNavigate();
  // 이름에 '님' 붙이는 helper 함수 (부양가족용)
  const addHonorific = name => `${name}님`;

  return (
    <SlideRightDialog isOpen={true} onClose={() => navigate(-1)} title="안내사항">
      <Wrapper>
        <Banner>
          <img src={speakerIcon} alt="연말정산 안내사항" />
          <Typography variant="body1Bold">연말정산 안내사항</Typography>
        </Banner>
        {/* 글 */}
        <Typography variant="body2Medium">
          안녕하세요, {taxChangePer?.person}님.
          <br />
          <br />
          저희 연말정산 시스템을 이용해 주셔서 감사합니다.
          <br />
          <br />
          이번 연말정산 세액 계산 과정에서 {taxChangePer?.person}
          {taxChangePer?.dependents?.length > 0
            ? `님과 부양가족인 ${taxChangePer?.dependents?.map(addHonorific).join(', ')}의 `
            : '님의 '}
          보험료 · 교육비 · 의료비 · 신용카드 · 기부금 항목 중 일부가 실제 요건을 충족하지 않음에도
          공제가 적용된 사실을 확인하였습니다.
          <br />
          <br />
          이에 따라 환급 또는 징수되는 세액에 조정이 있었음을 알려드리오니 양해 부탁드립니다.
          <br />
          <br />
          현재 계산된 세액은 적정 기준에 따라 재계산되어 반영된 상태입니다.
          <br /> (오류 수정 후 모의계산 결과를 재반영하였습니다.)
          <br />
          <br />
          이로 인해 불편을 끼쳐드린 점 사과드리며, 앞으로 더욱 정확하고 신뢰할 수 있는 서비스를
          제공하기 위해 최선을 다하겠습니다.
          <br />
          <br />
          추가 문의사항이 있으실 경우, 하단의 채팅상담 버튼을 통해 문의해 주시기 바랍니다.
          감사합니다.
        </Typography>
        {/* 버튼 */}
        <ChatButton onClick={() => navigate('/chat')}>
          채팅상담 바로가기
          <img src={chatIcon} alt="채팅상담 바로가기" />
        </ChatButton>
      </Wrapper>
    </SlideRightDialog>
  );
};

export default TaxChangeAlert;
